// extracted by mini-css-extract-plugin
export default {"content":"vB+AZ","container":"xuKp3","formText":"TDciM","preFooterForm":"Drnzg","wrapperForm":"iMg0A","form":"O+LLG"};